import { render, staticRenderFns } from "./NIHSS.vue?vue&type=template&id=3cd1c953&"
import script from "./NIHSS.vue?vue&type=script&lang=ts&"
export * from "./NIHSS.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cd1c953')) {
      api.createRecord('3cd1c953', component.options)
    } else {
      api.reload('3cd1c953', component.options)
    }
    module.hot.accept("./NIHSS.vue?vue&type=template&id=3cd1c953&", function () {
      api.rerender('3cd1c953', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/standalone/NIHSS.vue"
export default component.exports